var map = {
	"./12.png": 40687,
	"./14.png": 85765,
	"./4.jpg": 19379,
	"./9.jpg": 91219,
	"./blog-2.jpg": 8478,
	"./blog-3.jpg": 15301,
	"./blog-5.png": 8690,
	"./blog-6.png": 14381,
	"./blog-single.jpg": 51029,
	"./blog.jpg": 2621,
	"./comment.jpg": 18560,
	"./img.png": 67056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9773;